import { render, staticRenderFns } from "./CompaniesAdd.vue?vue&type=template&id=03c59c05&"
import script from "./CompaniesAdd.vue?vue&type=script&lang=js&"
export * from "./CompaniesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports